import "./simpleSearch.styl";

const template = `
<input
	class="form-control"
	type='text'
	ng-model='$ctrl.$parent.tableConfiguration.search'
	ng-model-options='{ debounce: 1000 }'
	ng-change='$ctrl.$parent.objects = []; $ctrl.$parent.$onInit();'
/>
`;
export const simpleSearchComponent = {
	template,
	bindings: {
		$parent: "="
	}
};


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/simpleSearch/simpleSearch.js
 **/